import { computationOptions } from "#app/computationOptions";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import {
  AssemblyWithChildren,
  computeQuoteRequestLinePrice,
  NO_OPTIMIZED_MACHINE_TIMES,
  NO_OPTIMIZED_MATERIAL_COSTS,
} from "shared";

export const getAreAllAssemblyChildrenAreQuoted = (
  assembly: AssemblyWithChildren<QuoteRequestLineDto> | undefined,
) => {
  if (!assembly) {
    return false;
  }

  return assembly.children.every((child) => {
    const { partCost } = computeQuoteRequestLinePrice(
      {
        quoteRequestLine: child.quoteRequestLine,
        optimizedMachineTimes: NO_OPTIMIZED_MACHINE_TIMES,
        optimizedMaterialCosts: NO_OPTIMIZED_MATERIAL_COSTS,
      },
      computationOptions,
    );

    return partCost !== 0;
  });
};
